export default {"src":"/_next/static/media/ethos-logo-white.b222ef97.svg","height":12,"width":66,"blurWidth":0,"blurHeight":0};